import { render, staticRenderFns } from "./TaskIssueDianFuStepTwoAddGoods.vue?vue&type=template&id=2d0bc4ad&"
import script from "./TaskIssueDianFuStepTwoAddGoods.vue?vue&type=script&lang=js&"
export * from "./TaskIssueDianFuStepTwoAddGoods.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueDianFuStepTwoAddGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports